import { useContext } from 'react';

import I18nContext from '../../../aurr/contexts/I18nContext';
import { ArticleResponse } from '../../article/type';

export function generateArticleEyebrow(articleResponse: ArticleResponse) {
  const { t } = useContext(I18nContext);
  const { fields } = articleResponse;
  const isTheaterTalk = fields.contentUsage === 'theaterTalk';

  const articleEyebrowFields = isTheaterTalk
    ? [t('Theater Talk', { ns: 'common' })]
    : [t('Article', { ns: 'common' })];

  if (fields.publishedDate) {
    articleEyebrowFields.push(
      new Date(fields.publishedDate).getFullYear().toString()
    );
  }
  return articleEyebrowFields.join(' / ');
}
